import clamp from "../common/helpers/clamp";
import Region from "./Region";

class BrowserConf {
  constructor({
    title,
    visStart,
    visEnd,
    start,
    end,
    state,
    trackConfs,
    genome,
    chromosome,
  }) {
    const { x0, x1 } = chromosome.region;
    const v0 = clamp(visStart, x0, x1 - 100);
    const v1 = clamp(visEnd, x0 + 100, x1);
    const s0 = clamp(start, x0, x1);
    const s1 = clamp(end, x0, x1);

    this.title = title;
    this.genome = genome;
    this.chromosome = chromosome;
    this.state = state;
    this.trackConfs = trackConfs;
    this.visRange = new Region(v0, v1, chromosome);
    this.selectedRange = new Region(s0, s1, chromosome);
  }
}

export default BrowserConf;
